import { defineAction } from '~/prix'
import { z } from 'zod'
import propertyImprovementsUpdateAction from './propertyImprovementsUpdate.action.json' with { type: 'json' }
import { propertyImprovementsObject } from '../propertyImprovementsObject'

const propertyImprovementsUpdateDefinition = defineAction({
  ...propertyImprovementsUpdateAction,
  input: propertyImprovementsObject,
  output: z.object({}),
})

export default propertyImprovementsUpdateDefinition
